import { isNullOrUndefined } from '@/utils/helpers';
import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
const DEFAULT_GROUP_NAME = 'Give your group a name';

const buildAccountGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const groups = buildAccountGetterObject('groups');
export const defaultGroupName = buildAccountGetterObject('defaultGroupName');
export const selectedGroup = buildAccountGetterObject('selectedGroup');
export const loading = buildAccountGetterObject('loading');
export const groupPathItems = buildAccountGetterObject('groupPathItems');
export const groupById = buildAccountGetterObject('groupById');

const getters = {
	[groups.getter]: (state) => state.groups,
	[groupById.getter]: (state, getters) => (groupId) => getters[groups.getter]?.find(({ id }) => id === groupId),
	[defaultGroupName.getter]: () => DEFAULT_GROUP_NAME,
	[selectedGroup.getter]: (state) => state.selectedGroup,
	[loading.getter]: (state) => state.loading,
	[groupPathItems.getter]: (state) => (group) => {
		const pathItems = [];
		let currentGroup = group;
		while (!isNullOrUndefined(currentGroup)) {
			pathItems.unshift(currentGroup);
			if (currentGroup.parent === null) {
				currentGroup = null;
			} else {
				currentGroup = state.groups.find((x) => x.id === currentGroup.parent);
			}
		}
		return pathItems;
	},
};

export default getters;
